import { IParentAccountService } from '@shared/interfaces/services';
import { AuthResponseModel } from '@shared/models/AuthResponseModel/AuthResponseModel';
import { TOKEN_NAME, USER_ROLE } from '@shared/models/constants';
import { ApiService } from '@shared/services';
import { ChildChangePasswordModel } from '@shared/models/Child';
import { signalService } from '@/shared/src/services/SignalService';
import environment from '@shared/environments/environment';

export class AccountService extends ApiService implements IParentAccountService {
  constructor() {
    super('/account');
  }

  login(authKey: string): Promise<void> {
    return this.get(`/login/${authKey}`).then(({ role, token }: AuthResponseModel) => {
      localStorage.setItem(TOKEN_NAME, token);
      localStorage.setItem(USER_ROLE, role);
    });
  }

  async logout(): Promise<void> {
    await signalService.close();
    localStorage.setItem(TOKEN_NAME, '');
    localStorage.setItem(USER_ROLE, '');
    return Promise.resolve(window.location.assign(`${environment.webSiteBaseUri}/login`));
  }

  changeChildPassword(params: ChildChangePasswordModel) {
    return this.post('Setting/parent/child/changePassword', params);
  }

  checkUsername(params: { userName: string }) {
    return this.post('/study/registration/check/userName', params)
      .then((value: any) => value?.success);
  }
}
